<ng-template #template>
  <label [class]="item.className" (mousedown)="model.onMouseDown()">
    <input type="radio"
      class="sv-visuallyhidden"
      [attr.name]="model.questionName" [attr.id]="model.getInputId(index)" [value]="item.value" [attr.aria-label]="model.ariaLabel"
      [disabled]="model.isDisabledAttr" [readonly]="model.isReadOnlyAttr" [checked]="model.value === item.value" (click)="onClick($event)"
      />
      <span [class]="model.cssClasses.itemText" [attr.data-text]="item.text" [model]="item.locText" sv-ng-string></span>
  </label>
</ng-template>